import { useQuery } from "@tanstack/react-query"
import { useLocation } from "wouter"
import { AvatarMenu } from "@rawa/ui/AvatarMenu"
import { fetchAuthSessionUser, postLogout } from "../modules/auth/api"
import { paths } from "../paths"

/**
 * The admin header's pill, wired to this app's sign-out endpoint.
 *
 * Renders nothing until the name arrives, and nothing at all if the probe
 * fails: the chrome sits outside the route guard, so it paints on the way to
 * sign-in too, and an empty pill there would be chrome for a session that does
 * not exist. Whether the page may be seen is the guard's call, not this one's.
 */
export function AdminAvatarMenu() {
  const [, navigate] = useLocation()
  const { data } = useQuery({
    queryKey: ["admin-user"],
    queryFn: fetchAuthSessionUser,
    meta: { source: "AdminAvatarMenu" },
  })

  async function signOut() {
    await postLogout()
    navigate(paths.login)
  }

  if (!data) return null
  return <AvatarMenu name={data.name} onSignOut={() => void signOut()} />
}
